import { MultiSelect } from '@mantine/core';
import { filter, includes } from 'lodash';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { FormInputWrapper } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/styled';
import { Z_INDEX } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { ClassifierOption } from '@dealstack/frontend/app/pages/Valuations/shared/entityClassiferBadgeConfig';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	options: ClassifierOption[];
	selectedValues: ClassifierOption[];
	onSelectionChange: (selectedValues: ClassifierOption[]) => void;
	placeholder?: string;
	width?: number | string;
}

export function BadgeMultiSelect({
	options,
	selectedValues,
	onSelectionChange,
	placeholder = 'Search...',
	width = '100%',
}: Props) {
	// Transform options to the format expected by Mantine MultiSelect
	const data = options.map((option) => ({
		value: option.value,
		label: option.label,
	}));

	return (
		<div data-testid={TEST_ELEMENT_IDS.BADGE_MULTI_SELECT} style={{ width }}>
			<FormInputWrapper>
				<MultiSelect
					data={data}
					value={selectedValues.map(({ value }) => value)}
					onChange={(value) => {
						const newSelection = filter(options, (option) =>
							includes(value, option.value)
						);

						onSelectionChange(newSelection);
					}}
					placeholder={placeholder}
					clearable
					size="sm"
					rightSection={<Icon variant="caret-down" size="vlg" />}
					nothingFoundMessage="No options available"
					styles={{
						rightSection: { pointerEvents: 'none' },
						wrapper: {
							minWidth: '100%',
							width: '100%',
						},
						input: {
							minWidth: '100%',
							width: '100%',
						},
						dropdown: {
							zIndex: Z_INDEX.MENU,
						},
					}}
					sx={{
						'input:focus:not([data-invalid])': {
							boxShadow: 'none',
						},
						'.mantine-MultiSelect-values': {
							flexWrap: 'nowrap',
							overflow: 'hidden',
							minWidth: '100%',
							width: '100%',
						},
						'.mantine-MultiSelect-value': {
							flexShrink: 0,
						},
						'.mantine-MultiSelect-input': {
							minWidth: '100% !important',
							width: '100% !important',
						},
					}}
				/>
			</FormInputWrapper>
		</div>
	);
}
